'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Area(icon, name) {
  this.gn = null;
  this.go = null;
  this.gn = icon;
  this.go = name;
}
export { $c_Lio_intela_sites_intelacloud_content_Area as $c_Lio_intela_sites_intelacloud_content_Area };
$p = $c_Lio_intela_sites_intelacloud_content_Area.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Area;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Area() {
}
export { $h_Lio_intela_sites_intelacloud_content_Area as $h_Lio_intela_sites_intelacloud_content_Area };
$h_Lio_intela_sites_intelacloud_content_Area.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 1330601372, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Area)) {
    var x = this.gn;
    var x$2 = x$0.gn;
    if ((x === x$2)) {
      return (this.go === x$0.go);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Area";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.gn;
  }
  if ((n === 1)) {
    return this.go;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Area(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bm)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Area as $isArrayOf_Lio_intela_sites_intelacloud_content_Area };
var $d_Lio_intela_sites_intelacloud_content_Area = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Area, "io.intela.sites.intelacloud.content.Area", ({
  bm: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Area as $d_Lio_intela_sites_intelacloud_content_Area };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Area.js.map
